/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Galleryclose1Inputs */

const en_galleryclose1 = /** @type {(inputs: Galleryclose1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close gallery`)
};

const de_galleryclose1 = /** @type {(inputs: Galleryclose1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galerie schließen`)
};

/**
* | output |
* | --- |
* | "Close gallery" |
*
* @param {Galleryclose1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const galleryclose1 = /** @type {((inputs?: Galleryclose1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Galleryclose1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_galleryclose1(inputs)
	return de_galleryclose1(inputs)
});
export { galleryclose1 as "galleryClose" }